import 'react-tooltip/dist/react-tooltip.css';

import { memo } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const InitializeTooltips = () => {
	return <ReactTooltip />;
};
const _InitializeTooltipsExport = memo(InitializeTooltips);

export { _InitializeTooltipsExport as InitializeTooltips };
